var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 23,
    viewBox: "0 0 33 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0.5C1.61929 0.5 0.5 1.61929 0.5 3V20C0.5 21.3807 1.61929 22.5 3 22.5H10.5V23H11.5V22.5H30C31.3807 22.5 32.5 21.3807 32.5 20V3C32.5 1.61929 31.3807 0.5 30 0.5H3ZM11.5 21.5H30C30.8284 21.5 31.5 20.8284 31.5 20V3C31.5 2.17157 30.8284 1.5 30 1.5H11.5V21.5ZM10.5 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V20C1.5 20.8284 2.17157 21.5 3 21.5H10.5V1.5Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar);
export default __webpack_public_path__ + "static/media/sidebar.c2b3ec5f499afa388d9c2382e7d19144.svg";
export { ForwardRef as ReactComponent };